exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Nunito:300,400,500,600|Source+Sans+Pro:300,400,500,600,700,800,900);", ""]);

// module
exports.push([module.id, ".selected-seats-list .selected-seat {\n  display: flex;\n  align-items: center;\n  width: 100%; }\n  .selected-seats-list .selected-seat .seat, .selected-seats-list .selected-seat .section {\n    width: 30%; }\n  .selected-seats-list .selected-seat .category-dropdown {\n    margin-right: 0;\n    margin-left: auto; }\n\n@media screen and (max-width: 1024px) {\n  .selected-seats-list .ant-divider {\n    display: none; }\n  .selected-seats-list .selected-seat {\n    flex-wrap: wrap; }\n    .selected-seats-list .selected-seat .seat {\n      width: 100%;\n      margin-top: 1rem; }\n    .selected-seats-list .selected-seat .section {\n      width: 100%;\n      margin-bottom: 1rem; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./src/components/PickSeatManually/SelectedSeatsList/SelectedSeatsList.scss
// module id = 1673
// module chunks = 0